import React from "react";
import { FormText } from "reactstrap";
import { TestSelector as BaseTestSelector } from "../TestSelector";
import { InputWrapper } from "./InputWrapper";

export const TestSelector = ({ children, input, label, meta, inputId, ...rest }) => {
  const invalid = Boolean(meta.touched && meta.error);

  return (
    <InputWrapper testId={inputId || rest["data-testid"]} label={label} required={rest.required} htmlFor={inputId}>
      <BaseTestSelector {...input} {...rest} inputId={inputId} valid={!invalid} />

      {meta.touched && meta.error && <FormText color="danger">{meta.error}</FormText>}

      {children}
    </InputWrapper>
  );
};
